import gsap from 'gsap'

class PrimaryCardHover {
    constructor (card) {
        if (!card) {
            return
        }
        this.card = card
        this.content = this.card.querySelector('.z-card__content-hidden')
        this.contentBottom = this.card.querySelector('.z-card__content-bottom')
        this.icon = this.card.querySelector('.z-icon')

        this.play = this.play.bind(this)
        this.reverse = this.reverse.bind(this)
    }

    addHoverEvents () {
        this.card.addEventListener('mouseenter', this.play)
        this.card.addEventListener('mouseleave', this.reverse)
    }

    removeHoverEvents () {
        this.card.removeEventListener('mouseenter', this.play)
        this.card.removeEventListener('mouseleave', this.reverse)
    }

    play () {
        gsap.to(this.content, { height: 'auto', opacity: 1 })
        gsap.to(this.contentBottom, { overflow: 'auto' })
    }

    reverse () {
        gsap.to(this.contentBottom, { overflow: 'hidden' })
        gsap.to(this.content, { height: 0, opacity: 0 })
    }

    playIcon () {
        gsap.to(this.icon, {rotate: '0deg'})
    }

    reverseIcon () {
        gsap.to(this.icon, {rotate: '180deg'})
    }
}

export default PrimaryCardHover